import { render } from "./ApprovedDetailsModal.vue?vue&type=template&id=58dcb314&scoped=true"
import script from "./ApprovedDetailsModal.vue?vue&type=script&lang=js"
export * from "./ApprovedDetailsModal.vue?vue&type=script&lang=js"

import "./ApprovedDetailsModal.vue?vue&type=style&index=0&id=58dcb314&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58dcb314"]])

export default __exports__